import * as actionTypes from './actionTypes';

export const openUpdateTeam=()=>({
    type:actionTypes.OPEN_UPDATE_TEAM
})

export const closeUpdateTeam=()=>({
    type:actionTypes.CLOSE_UPDATE_TEAM
})